import { useQuery } from '@apollo/client';
import { useContext, useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { AuthenticatorContext } from 'Authenticator';
import { ME } from 'query/team';
import { MeType } from 'models/me';
import { recordUsagePageview, resetUsageAnalytics, setAnalyticsUser } from 'lib/usageAnalytics';
import { isSupportStaff } from './ACLWrapper';

export default function UsageAnalyticsGate() {
  const { isTokenValid } = useContext(AuthenticatorContext);
  const location = useLocation();
  // Verify staff status with the backend before allowing any analytics capture.
  const { data, error, loading } = useQuery<{ res: MeType }>(ME, {
    skip: !isTokenValid,
    fetchPolicy: 'network-only',
  });
  const me = data?.res;
  useLayoutEffect(() => {
    const verified = isTokenValid && !loading && !error && me;
    setAnalyticsUser(verified ? {
      id: verified.id,
      isStaff: verified.isStaff,
      isSuperuser: verified.isSuperuser,
      excluded: !verified.isActive || isSupportStaff(verified.email || ''),
    } : undefined);
    if (verified && !['/login', '/reset'].includes(location.pathname)) {
      recordUsagePageview(location.pathname);
    }
  }, [isTokenValid, loading, error, me?.id, me?.isStaff, me?.isSuperuser,
    me?.isActive, me?.email, location.pathname]);
  useLayoutEffect(() => resetUsageAnalytics, []);
  return null;
}
